<form [formGroup]="permissionGroupForm">
  <div class="form-row row">
    <div class="form-group">
      <label for="name" class="control-label required">{{ 'i18n.domain.assets.asset-storage-settings.form.name' |
        translate }}</label>
      <input id="name" type="text" class="form-control" formControlName="name" />
      <app-error-messages [control]="permissionGroupForm.get('name')"></app-error-messages>
    </div>
  </div>
</form>